import { render, staticRenderFns } from "./CreateProcessor.vue?vue&type=template&id=8a932ec0"
import script from "./CreateProcessor.vue?vue&type=script&lang=js"
export * from "./CreateProcessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports